/* global __webpack_public_path__ */

const normalizeDistRoot = (value) => {
  if (typeof value !== "string" || value.length === 0) {
    return "";
  }

  return value.endsWith("/") ? value : `${value}/`;
};

const findDistRootFromScripts = () => {
  if (typeof document === "undefined") {
    return "";
  }

  const scripts = Array.from(document.getElementsByTagName("script"));

  for (let index = scripts.length - 1; index >= 0; index -= 1) {
    const src = scripts[index]?.src || "";
    const match = src.match(/^(.*\/dist\/)(?:app|react)\/[^/]+(?:\?.*)?$/);

    if (match && match[1]) {
      return match[1];
    }
  }

  return "";
};

const distRoot =
  findDistRootFromScripts() ||
  (typeof window !== "undefined" && normalizeDistRoot(window.__wpackIounderstrapChilddist));

if (distRoot) {
  // Async chunks append their own app directory ("react/" or "app/") in the runtime.
  __webpack_public_path__ = distRoot;
}
